import { jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { colors } from '../../tokens/colors/colors.js';
import { fontWeight } from '../../tokens/fontWeight.js';

function Text({ variant, color, marginBottom = 0, textAlign = "unset", as, style, classNames: _classNames, hidden, children, textTransform, textDecoration, ...props }) {
    const _style = {
        color: getTextColor({ color }),
        marginBottom,
        textAlign,
        textTransform,
        textDecoration,
        ...style,
    };
    switch (variant) {
        case "heading1":
            return (jsx(Heading1, { as: as, style: _style, hidden: hidden, ...props, children: children }));
        case "heading2":
            return (jsx(Heading2, { as: as, style: _style, hidden: hidden, ...props, children: children }));
        case "heading3":
            return (jsx(Heading3, { as: as, style: _style, hidden: hidden, ...props, children: children }));
        case "subtitle":
            return (jsx(Subtitle, { as: as, style: _style, hidden: hidden, ...props, children: children }));
        case "subtitleS":
            return (jsx(SubtitleS, { as: as, style: _style, hidden: hidden, ...props, children: children }));
        case "body":
            return (jsx(Body, { as: as, style: _style, hidden: hidden, ...props, children: children }));
        case "bodyS":
            return (jsx(BodyS, { as: as, style: _style, hidden: hidden, ...props, children: children }));
        case "bodyXS":
            return (jsx(BodyXS, { as: as, style: _style, hidden: hidden, ...props, children: children }));
        case "nano":
            return (jsx(Nano, { as: as, style: _style, hidden: hidden, ...props, children: children }));
        default:
            return (jsx(Body, { as: as, style: _style, hidden: hidden, ...props, children: children }));
    }
}
function getTextColor({ color }) {
    switch (color) {
        case "primary":
            return colors.textPrimary;
        case "secondary":
            return colors.textSecondary;
        case "tertiary":
            return colors.textTertiary;
        case "emergency":
            return colors.systemErrorDark;
        case "good":
            return colors.systemGoodDark;
        case "warning":
            return colors.systemWarningDark;
        case "unset":
            return "unset";
        case "contrast":
            return colors.textContrast;
        default:
            return colors.textPrimary;
    }
}
const Heading1Mixin = css `
  font-size: 2rem;
  font-weight: ${fontWeight.regular};
  line-height: 1.4;
  margin: 0;
  color: ${colors.textPrimary};
`;
const Heading1 = styled.div `
  ${Heading1Mixin}
`;
const Heading2Mixin = css `
  font-size: 1.5rem;
  font-weight: ${fontWeight.medium};
  line-height: 1.4;
  margin: 0;
  color: ${colors.textPrimary};
`;
const Heading2 = styled.div `
  ${Heading2Mixin}
`;
const Heading3Mixin = css `
  font-size: 1.125rem;
  font-weight: ${fontWeight.semiBold};
  line-height: 1.5;
  margin: 0;
  color: ${colors.textPrimary};
`;
const Heading3 = styled.div `
  ${Heading3Mixin}
`;
const SubtitleMixin = css `
  font-size: 1rem;
  font-weight: ${fontWeight.semiBold};
  line-height: 1.5;
  margin: 0;
  color: ${colors.textPrimary};
`;
const Subtitle = styled.div `
  ${SubtitleMixin}
`;
const SubtitleSMixin = css `
  font-size: 0.875rem;
  font-weight: ${fontWeight.semiBold};
  line-height: 1.5;
  margin: 0;
  color: ${colors.textPrimary};
`;
const SubtitleS = styled.div `
  ${SubtitleSMixin}
`;
const BodyMixin = css `
  font-size: 1rem;
  font-weight: ${fontWeight.regular};
  line-height: 1.5;
  margin: 0;
  color: ${colors.textPrimary};
`;
const Body = styled.div `
  ${BodyMixin}
`;
const BodySMixin = css `
  font-size: 0.875rem;
  font-weight: ${fontWeight.regular};
  margin: 0;
  line-height: 1.5;
  color: ${colors.textPrimary};
`;
const BodyS = styled.div `
  ${BodySMixin}
`;
const NanoMixin = css `
  font-size: 0.75rem;
  font-weight: ${fontWeight.regular};
  line-height: 1.5;
  margin: 0;
  color: ${colors.textPrimary};
`;
const Nano = styled.div `
  ${NanoMixin}
`;
const BodyXSMixin = css `
  font-size: 0.8125rem;
  font-weight: ${fontWeight.regular};
  line-height: 1.5;
  margin: 0;
  letter-spacing: 0.01625em;
  color: ${colors.textPrimary};
`;
const BodyXS = styled.div `
  ${BodyXSMixin}
`;

export { BodyMixin, BodySMixin, BodyXSMixin, Heading1Mixin, Heading2Mixin, Heading3Mixin, NanoMixin, SubtitleMixin, SubtitleSMixin, Text };
